module.exports = function(){











    var showContainer = function(){

        $('[js-sd-container]').addClass('is-visible');

        $('html, body').animate({
            scrollTop: $('[js-sd-scroll-pointer]').offset().top - 50
        }, 200);

        setTimeout(function(){
            $('[js-sd-container]').addClass('is-animated-in');
        }, 10);

    };


    var hideForm = function(callback) {

        $('[js-sd-form]').addClass('is-animated-out');
        setTimeout(function(){
            $('[js-sd-form]').addClass('is-hidden');
            callback.apply(this);
        }, 500);

    };














    var showForm = function() {

        $('[js-sd-callback]').addClass('is-hidden');
        $('[js-sd-form]').removeClass('is-hidden');

        $('[js-sd-section]').removeClass('is-visible');
        $('[js-sd-section]').eq(0).addClass('is-visible');

        setTimeout(function(){
            $('[js-sd-form]').removeClass('is-animated-out');
        }, 10);

    };

    var hideContainer = function(callback){

        $('[js-sd-container]').removeClass('is-animated-in');
        setTimeout(function(){

            $('html, body').animate({
                scrollTop: $('[js-sd-scroll-pointer]').offset().top - 50
            }, 200);

            $('[js-sd-container]').removeClass('is-visible');
            $('[js-sd-products-dynamic]').html('');

            callback.apply(this);

        }, 500);


    };




    var nextSection = function(thisEl){

        //window.jBoxLatestTooltip.close();
        var section = $(thisEl).closest('[js-sd-section]');
        section.removeClass('is-visible');
        section.next('[js-sd-section]').addClass('is-visible');

    };



    var prevSection = function(thisEl){

        //window.jBoxLatestTooltip.close();
        var section = $(thisEl).closest('[js-sd-section]');
        section.removeClass('is-visible');
        section.prev('[js-sd-section]').addClass('is-visible');

    };











    var changeTexts = function(requestData, data){


        if (requestData['Function']) {
            $('[js-sd-function]').show().text(requestData['Function']);
        } else {
            $('[js-sd-function]').hide();
        }

        if (requestData['Style']) {
            $('[js-sd-style]').show().text(requestData['Style']);
        } else {
            $('[js-sd-style]').hide();
        }

        if (requestData['Height']) {
            $('[js-sd-height]').show().text(requestData['Height']);
        } else {
            $('[js-sd-height]').hide();
        }

        if (requestData['BodyType']) {
            $('[js-sd-bodytype]').show().text(requestData['BodyType']);
        } else {
            $('[js-sd-bodytype]').hide();
        }


        if (data.data.message) {
            $('[js-sd-message]').show().text(data.data.message);
        } else {
            $('[js-sd-message]').hide();
        }


    };












    var renderSdItems = function(web_products){

        var itemTemplate = require('../templates/general-item.hbs');

        $(web_products).each(function(index, el) {

            if (el.wa_web_product) {

                window.eph.getSingleProduct(el.wa_web_product.Id, 0, 0, function(templateData){
                    $('[js-sd-products-dynamic]').append( itemTemplate(templateData) );
                });

            }

        });

    };










    $('[js-sd-form]').on('submit', function(event) {
        event.preventDefault();

        var form = $(this);
        var submitBtn = form.find('button[type="submit"]');

        var requestData = form.serializeFormJSON();

        $('[js-sd-callback]').addClass('is-hidden');
        submitBtn.prop('disabled', true);

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: requestData,
            dataType: 'json',

            complete: function(jqXHR, textStatus){
                submitBtn.prop('disabled', false);
            },

            success: function(data, textStatus, jqXHR){

                hideForm(function(){
                    showContainer();
                });
                changeTexts(requestData, data);

                renderSdItems(data.data.web_products);

            },

            error: function(jqXHR, textStatus, errorThrown){
                $('[js-sd-callback]')
                    .text('Couldn\'t match any products. Maybe different options would match better?')
                    .removeClass('is-hidden');
            },

        });



    });













    $(document).on('click', '[js-sd-section] input', function(event) {
        event.preventDefault();
        nextSection(this);
    });


    $(document).on('click', '[js-sd-prev-btn]', function(event) {
        event.preventDefault();
        prevSection(this);
    });




    $(document).on('click', '[js-sd-back-btn]', function(event) {
        event.preventDefault();

        hideContainer(function(){
            showForm();
        });

    });









    $(document).on('click', '[js-sd-btn-again]', function(event) {
        event.preventDefault();

        $('[js-sd-callback]').addClass('is-hidden');
        $('[js-sd-section]').removeClass('is-visible');
        $('[js-sd-section]').eq(0).addClass('is-visible');
    });





}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/integration/style-discovery.js